import { useDelegateAdHocFormInputOptions } from '../../../../../../../../hooks/confirmPurchase/delegate/useDelegateAdHocFormInputOptions';
import { useDelegateAdHocFormTransformedInputFields } from '../../../../../../../../hooks/confirmPurchase/delegate/useDelegateAdHocFormTransformedInputFields';
import { PricingFormInput } from '../../../../../../../../store/features/delegate/types';
import {
  PricingFormInputLayout,
  PricingFormInputType,
} from '../../../../../../../../types/enums';
import SelectField from '../../../../../../../../shared/formElements/SelectField';
import AdHocRadioGroupField from '../AdHocRadioGroupField';
import { DelegateFormProps } from '../../../../index';
import AdHocCheckboxGroupField from '../AdHocCheckboxGroupField';

export interface AdHocFieldWithOptionsProps
  extends Pick<DelegateFormProps, 'delegateUuid'> {
  formInput: PricingFormInput;
  allFormInputs: PricingFormInput[];
}

export default function AdHocFieldWithOptions(
  props: AdHocFieldWithOptionsProps,
) {
  const { formInput, allFormInputs, delegateUuid } = props;

  const {
    type,
    options,
    optionsSource,
    subLabel,
    placeholder,
    layout = PricingFormInputLayout.ROW,
  } = formInput;

  const { fieldName, fieldLabel, fieldRequired } =
    useDelegateAdHocFormTransformedInputFields(formInput);

  const inputOptions = useDelegateAdHocFormInputOptions({
    formInputs: allFormInputs,
    options,
    delegateUuid,
    optionsSource,
  });

  switch (type) {
    case PricingFormInputType.SELECT: {
      return inputOptions.length === 0 && fieldRequired ? null : (
        <SelectField
          name={fieldName}
          label={fieldLabel}
          options={inputOptions}
          placeholder={placeholder}
          helperText={subLabel}
          rules={{ required: fieldRequired }}
        />
      );
    }

    case PricingFormInputType.RADIO: {
      return (
        <AdHocRadioGroupField
          name={`${fieldName}.__radio__`}
          label={fieldLabel}
          helperText={subLabel}
          options={inputOptions}
          layout={layout}
          rules={{ required: fieldRequired }}
        />
      );
    }

    case PricingFormInputType.CHECKBOX_GROUP: {
      return (
        <AdHocCheckboxGroupField
          name={fieldName}
          label={fieldLabel}
          helperText={subLabel}
          options={inputOptions}
          layout={layout}
          rules={{ atLeastOne: fieldRequired }}
        />
      );
    }

    default: {
      return null;
    }
  }
}
